import { Box, Typography, Stack } from "@mui/material";
import AuthShell from "../../components/NewLogin/AuthShell";
import AuthFormWrapper from "../../components/NewLogin/AuthFormWrapper";
import images from "../../constant/images";
import { AnimatePresence, motion } from "framer-motion";
import { pageTransition, pageVariants } from "./Animation";
import { useTranslation } from "react-i18next";

const FONT = "'Euclid Circular B', sans-serif";
const FONT_REGULAR = "'Euclid Circular Light', sans-serif";


/**
 * EmailSentPage
 * Shown after a successful password reset request.
 *
 * Props:
 *   onBackToLogin – () => void
 */
const EmailSentPage = ({ onBackToLogin }) => {
  const {t} = useTranslation();
  return (
    <AuthShell isLoading>
      <AuthFormWrapper maxWidth={300}>
        <AnimatePresence mode="wait">
          <motion.div
            key="login"
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pageTransition}
          >
            {/* ── SCAI logo + heading ── */}
            <Stack alignItems="center" spacing="0.276rem" sx={{ mb: "1.857rem" }} gap={"1.429rem"}>
              <Box component="img" src={images.SCAI} />

              <Stack alignItems="center" spacing="0.276rem">
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontSize: "1.8rem",
                    fontWeight: 400,
                    lineHeight: "1.857rem",
                    color: "#07080B",
                    textAlign: "center",
                  }}
                >
                  {t("HEY_WE_GOT_YOUR_BACK")} 😎
                </Typography>
                <Typography
                  sx={{
                    fontFamily: FONT_REGULAR,
                    fontSize: "1.143rem",
                    fontWeight: 300,
                    lineHeight: "1.714rem",
                    color: "#474849",
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  {t("IF_YOUR_EMAIL_IS_REGISTERED")}
                  <br />
                  {t("PLEASE_CHECK_INBOX")}
                </Typography>
              </Stack>
            </Stack>

            {/* ── Back to login ── */}
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing="0.667rem"
              component="button"
              onClick={onBackToLogin}
              sx={{
                background: "none",
                border: "none",
                cursor: "pointer",
                p: 0,
                width: "fit-content",
                mx: "auto",
                "&:hover .back-label": { textDecoration: "underline" },
              }}
            >
              <Typography
                className="back-label"
                sx={{
                  fontFamily: FONT,
                  fontSize: "0.852rem",
                  fontWeight: 300,
                  lineHeight: "1.238rem",
                  color: "rgba(7, 8, 11, 0.7)",
                }}
              >
                {t("Back_to_login")}
              </Typography>
              {/* Circular back-arrow icon */}
              <Box sx={{ position: "relative", width: "1.905rem", height: "1.55rem" }}>
                <Box
                  component="img"
                  src={images.BackArrow}
                />
              </Box>
            </Stack>
          </motion.div>
        </AnimatePresence>
      </AuthFormWrapper>
    </AuthShell>
  );
};

export default EmailSentPage;